import { render } from "./orderForm.vue?vue&type=template&id=13054190&scoped=true&ts=true"
import script from "./orderForm.vue?vue&type=script&lang=ts"
export * from "./orderForm.vue?vue&type=script&lang=ts"

import "./orderForm.vue?vue&type=style&index=0&id=13054190&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13054190"]])

export default __exports__